import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

export const set_delete_objects = createAsyncThunk(
  'delete_objects',
  async (data, { rejectWithValue }) => {
    return data;
  }
);

const initialState = {
  delete_items: [],
  latest_delete_item: {},
  delete_loading: false,
};

const DeleteObjectSlice = createSlice({
  name: 'data',
  initialState,
  extraReducers: (builder) => {
    builder
      // Handling API call pending state
      .addCase(set_delete_objects.pending, (state) => {
        state.delete_loading = true; // Set loading state to true
      })

      // Handling API call success response
      .addCase(set_delete_objects.fulfilled, (state, action) => {
        state.delete_loading = false;
        if (action.payload.type == 'clearAll') {
          state.delete_items = [];
          state.latest_delete_item = {};
        } else {
          state.delete_items = [...state.delete_items, action.payload.data];
          state.latest_delete_item = action.payload.data;
        }
      })

      // Handling API call failure response
      .addCase(set_delete_objects.rejected, (state) => {
        state.delete_loading = false; // Set loading state to false on failure
      });
  },
});

export default DeleteObjectSlice.reducer;
